/* Sortiert ein Array aus Wartungen nach
 * 1. kleineres remaining_h nach oben
 * 2. kleineres Intervall nach oben
 * 3. kleinere Komponente nach oben
 * Das sorgt dafür, dass die dringlichsten Wartungen
 * immer oben erscheinen.
 */
export const sortWartungen = (a, b) => {
	if (a.remaining_h < b.remaining_h) {
		return 1;
	} else if (a.remaining_h > b.remaining_h) {
		return -1;
	}
	if (a.interval_h < b.interval_h) {
		return 1;
	} else if (a.interval_h > b.interval_h) {
		return -1;
	}
	if (a.component < b.component) {
		return 1;
	} else if (a.component > b.component) {
		return -1;
	}
	return 0;
};
